import { useStateMachine } from "little-state-machine";
import logo from "assets/Whitespace_Logo_Colour.svg";
import { HwrcMenuWrapper } from "components/HwrcMenuWrapper/HwrcMenuWrapper";
import {
  Container, Row, Col, Image
}
  from "react-bootstrap";
import "./banner.scss";

const Banner = () => {
  const { state } = useStateMachine();

  const pageTitle: string = state.systemSettings?.portalName ?? "";

  return (
    <>

      <HwrcMenuWrapper />
      <section className="banner">
        <Container fluid>
          <Row>
            <Col xs={{ span: 12, order: 2 }} sm={{ span: 4, order: 1 }}>
              <h1 className="title" data-testid="banner-title">{pageTitle}</h1>
            </Col>
            <Col xs={{ span: 12, order: 1 }} sm={{ span: 4, order: 2 }} className="d-none d-sm-block">
              <a
                href="https://whitespacews.com/"
                title="Whitespace Work Software"
                target="_blank"
                rel="noreferrer"
              >
                <Image src={logo} alt="Whitespace Logo" height={52} />
              </a>
            </Col>
            <Col xs={{ span: 12, order: 1 }} sm={{ span: 4, order: 2 }} className="justify-content-end d-none d-sm-flex">
              {state.systemSettings
              && <Image data-testid="companyLogo" src={`/assets/images/${state.systemSettings!.logoFilename}`} alt="Company Logo" height={52} />}
            </Col>
          </Row>
        </Container>
      </section>
    </>
  );
};

export default Banner;
